export const repairDataList = [
  {
    prop: 'relicFromUserId',
    label: '建筑编号',
    width: 80
    // sortable: 'custom'
  },
  {
    prop: 'relicName',
    label: '名称',
    width: 210
  },
  {
    prop: 'recordFromUserId',
    label: '记录编号',
    width: 125
  },
  {
    prop: 'acceptanceDate',
    label: '动工日期',
    width: 145
  },
  {
    prop: 'completionDate',
    label: '竣工日期',
    width: 135
    // sortable: 'custom'
  },
  {
    prop: 'constructionUnit',
    label: '负责单位',
    width: 135
  },
  {
    prop: 'constructionUnitContact',
    label: '联系电话',
    width: 135
  }
];
